/* 🤖 this file was generated by svg-to-ts */
export const matIconWarning: {
  name: 'warning';
  data: string;
} = {
  name: 'warning',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>`
};
